import { JWT_STORAGE_KEY } from '../config/jwt';

export const removeAuthToken = () => localStorage.removeItem(JWT_STORAGE_KEY);
